import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaShieldAlt, FaInfoCircle } from 'react-icons/fa';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <h1>Добро пожаловать в MotoQR</h1>
      <p>Сервис экстренных контактов для владельцев экипировки BRO с помощью QR-кодов</p>
          
      <div className="home-info">
        <h2>Как это работает</h2>
        <ol>
          <li>
            <span>Приобретите экипировку компании BRO с QR-кодом</span>
            <p className="step-description">Каждый элемент экипировки BRO содержит уникальный QR-код для вашей безопасности.</p>
          </li>
          <li>
            <span>Зарегистрируйте свои экстренные контакты</span>
            <p className="step-description">Добавьте важную контактную информацию, которая может понадобиться в случае непредвиденной ситуации.</p>
          </li>
          <li>
            <span>В случае происшествия, спасатели могут отсканировать QR-код</span>
            <p className="step-description">При сканировании QR-кода на вашей экипировке, спасатели получат доступ к вашим экстренным контактам.</p>
          </li>
          <li>
            <span>Обновляйте информацию в любое время</span>
            <p className="step-description">Ваши экстренные контакты всегда актуальны - просто войдите в систему для внесения изменений.</p>
          </li>
        </ol>
      </div>
      
      <div className="home-features">
        <div className="feature-card">
          <div className="feature-card-content">
            <div className="feature-icon">
              <FaCheckCircle size={40} color="#3a6ea5" />
            </div>
            <div className="feature-text">
              <h3>Просто</h3>
              <p>Легко регистрируйте и обновляйте экстренные контакты с помощью нашего интуитивно понятного интерфейса</p>
            </div>
          </div>
        </div>
        
        <div className="feature-card">
          <div className="feature-card-content">
            <div className="feature-icon">
              <FaShieldAlt size={40} color="#3a6ea5" />
            </div>
            <div className="feature-text">
              <h3>Безопасно</h3>
              <p>Ваша контактная информация защищена и доступна только через QR-код на вашей экипировке BRO</p>
            </div>
          </div>
        </div>
        
        <div className="feature-card">
          <div className="feature-card-content">
            <div className="feature-icon">
              <FaInfoCircle size={40} color="#3a6ea5" />
            </div>
            <div className="feature-text">
              <h3>Жизненно важно</h3>
              <p>В экстренной ситуации спасатели быстро получат доступ к вашим контактным данным для оказания своевременной помощи</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
